import { useState } from "react";
import { Input } from "@/components/ui/input";
import { UserName } from "@/components/UserName";
import { draftAct } from "@/components/sales/draft/draftApi";
import { ShieldAlert, ShieldCheck } from "lucide-react";

// THE DONOR FIREWALL on the screen: a part listing that names its own donor truck is blocked, the match named. Take the
// words out — or, with "Approve and publish", override with a reason (logged; a new match blocks again).
export function DraftFirewall({ v, onView }) {
  const [why, setWhy] = useState("");
  const fw = v.firewall;
  if (!fw || (!fw.hits.length && !fw.override)) return null;
  if (fw.covered) return (
    <p data-testid="sales-draft-firewall-overridden" className="rounded-xl border border-amber-300 bg-amber-50 p-3 text-sm text-amber-950 flex gap-2">
      <ShieldCheck className="w-5 h-5 shrink-0" /><span>Donor firewall overridden by <UserName email={fw.override.by} /> — “{fw.override.reason.replace(/[.!?]+$/, "")}”.</span>
    </p>
  );
  if (!fw.hits.length) return null;
  return (
    <section data-testid="sales-draft-firewall" className="rounded-xl border-2 border-red-300 bg-red-50 p-3 space-y-2 text-sm text-red-950">
      <div className="font-bold flex items-center gap-2"><ShieldAlert className="w-5 h-5" />It names its own donor truck — it can't go public like this</div>
      <ul className="list-disc pl-5" data-testid="sales-draft-firewall-hits">
        {fw.hits.map((h, i) => <li key={i} data-testid={`sales-draft-firewall-hit-${i}`}><b>{h.what}</b> in the {h.field.toLowerCase()}</li>)}
      </ul>
      <p>Take those words out of the listing. A part listing never says anything about the truck it came off.</p>
      {v.can.approve && (
        <div className="flex flex-wrap gap-2 items-center">
          <Input data-testid="sales-draft-firewall-reason" value={why} onChange={(e) => setWhy(e.target.value)} placeholder="Why these words are not about its donor truck" className="h-11 flex-1 min-w-[220px] bg-white" />
          <button type="button" data-testid="sales-draft-firewall-override" disabled={why.trim().length < 8}
            onClick={async () => { if (await draftAct(v, "post", "/override", { reason: why }, onView)) setWhy(""); }}
            className="h-11 px-4 rounded-lg border-2 border-red-700 bg-white text-red-800 font-bold disabled:opacity-40">Override with this reason</button>
        </div>
      )}
    </section>
  );
}
